import script from "./KillSwitchConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./KillSwitchConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./KillSwitchConfirmModal.vue?vue&type=style&index=0&id=ab8d2540&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab8d2540"]])

export default __exports__